<template>
  <div class="bar">
    <a-tooltip placement="bottom" :getPopupContainer="(target) => target.parentNode" class="icon">
      <template #title>放大</template>
      <a-icon type="plus-circle" @click="changeEvent('zoomIn')" class="iconBtn" />
    </a-tooltip>
    <a-tooltip placement="bottom" :getPopupContainer="(target) => target.parentNode" class="icon">
      <template #title>缩小</template>
      <a-icon type="minus-circle" @click="changeEvent('zoomOut')" class="iconBtn" />
    </a-tooltip>
    <a-tooltip placement="bottom" :getPopupContainer="(target) => target.parentNode" class="icon">
      <template #title>移动</template>
      <a-icon type="drag" @click="changeEvent('move')" class="iconBtn" />
    </a-tooltip>
    <a-tooltip placement="bottom" :getPopupContainer="(target) => target.parentNode" class="icon">
      <template #title>全屏</template>
      <a-icon type="fullscreen" @click="changeEvent('fullScreen')" class="iconBtn" />
    </a-tooltip>
    <div class="status" style="display:none;">
      当前状态：{{ currentStatus }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Topbar',
  components: {
  },
  props: {
    currentStatus: {
      type: String,
      default: 'DEFAULT'
    }
  },
  data() {
    return {
      // 绘图参数
      config: {
        path_lineWidth: 1,
        path_strokeStyle: '#409EFF',
        anchor_lineWidth: 1,
        anchor_strokeStyle: '#f00'
      }
    }
  },
  methods: {
    changeEvent(eventName) {
      this.$emit('topBarEvent', eventName)
    },
    formatTooltip(val) {
      return parseInt(val - 50)
    }
  }
}
</script>


<style lang="less" scoped>
.bar {
  height: 30px;
  margin: 5px 0px;
}

.icon {
  height: 30px;
  width: 30px;
}

.iconBtn {
  box-sizing: border-box;
  height: 30px;
  width: 30px;
  line-height: 30px;
  font-size: 20px;
  padding: 0 5px;
  cursor: pointer;

  &:nth-child(1) {
    margin-left: 5px;
  }

  &:hover {
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.4);
  }
}
.status {
  float: right;
  margin-top: 8px;
  width: 160px;
  font-size: 14px;
}
</style>

<style scoped>
.text-container {
  display: inline-block;
  vertical-align: middle;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  margin-bottom: 10px;
  vertical-align: middle;
  padding: 0 4px;
}

.text {
  display: inline-block;
  margin-right: 8px;
}

</style>
